// extracted by mini-css-extract-plugin
export var bg = "contactForm-module--bg--0b9e3";
export var checked = "contactForm-module--checked--6653e";
export var contactForm = "contactForm-module--contact-form--07081";
export var contactLabel = "contactForm-module--contact-label--ee9c8";
export var customCheckbox = "contactForm-module--custom-checkbox--493a0";
export var formContent = "contactForm-module--form-content--1d760";
export var formShortcode = "contactForm-module--form-shortcode--b732e";
export var formText = "contactForm-module--form-text--c89a4";
export var thankYou = "contactForm-module--thank-you--97cec";
export var title = "contactForm-module--title--2ad37";
export var titleBg = "contactForm-module--title-bg--8470e";
export var wpcf7Spinner = "contactForm-module--wpcf7-spinner--85e3c";